import NiceModal from '@ebay/nice-modal-react';

export const dismissAllNiceModals = (modalIds: string[]) => {
  modalIds.forEach((id) => NiceModal.remove(id));
};
